import React from "react";
import { FiMessageSquare } from "react-icons/fi";

const CommunicationsTab = ({ selectedClientData }) => {
    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Communications</h3>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                    <FiMessageSquare className="h-12 w-12 text-gray-500 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        No Communications
                    </h3>
                    <p className="text-gray-600 mb-4">
                        This client doesn't have any Communications yet.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CommunicationsTab;